import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions'
import "firebase/storage";  
import "firebase/analytics"; 

//console.log('projectId', process.env.REACT_APP_PROJECT_ID)
const config = { 
    apiKey: process.env.REACT_APP_APIKEY_FIREBASE,
    authDomain: process.env.REACT_APP_AUTHDOMAIN_FIREBASE,
    databaseURL: process.env.REACT_APP_DATABASE_FIREBASE,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STOREBUCKET_FIREBASE,
    messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID_FIREBASE,
    appId: process.env.REACT_APP_APPID_FIREBASE,
    measurementId: process.env.REACT_APP_MEASUREMENTID_FIREBASE,
};

const Firebase = firebase.initializeApp(config);
const Analytics =  Firebase.analytics();
const Db = Firebase.firestore();
const Functions = Firebase.functions();
const Auth = Firebase.auth(); 

export { Auth, Db, Analytics, Functions }
export default firebase;